import { render, staticRenderFns } from "./unavailable_spklu_dc_v2.vue?vue&type=template&id=0c19f85a&scoped=true&"
import script from "./unavailable_spklu_dc_v2.vue?vue&type=script&lang=js&"
export * from "./unavailable_spklu_dc_v2.vue?vue&type=script&lang=js&"
import style0 from "./unavailable_spklu_dc_v2.vue?vue&type=style&index=0&id=0c19f85a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c19f85a",
  null
  
)

export default component.exports